// Third-party libraries
import React, { Fragment } from "react";
import { Link } from "react-router-dom";

import { Meta } from "../utilities";

function Rules() {
  return (
    <Fragment>
      <Meta
        title="Rouleur Derby Returns!"
        description="The exciting fantasy cycling game is back: faster, more RESTful, and better looking."
      />
      <h1>Rouleur Derby Returns</h1>
      <h4 className="deck">After a long break, the popular game is back to entertain and challenge fans of professional cycling.</h4>
      <p style={{marginTop: "2rem"}}><em>March 11, 2019</em></p>
      <p>
        <strong>EVANSTON, ILLINOIS—</strong>No longer must cycling fans travel to Europe to experience the thrill of
        cycling bookmaking.
      </p>
      <p>
        Rouleur Derby, the exciting fantasy game that lets players bet on
        professional cycling, is thrilled to announce its return for the 2019
        season.
      </p>
      <p>
        Presented by{" "}
        <a
          href="https://www.wideanglepodium.com"
          rel="noopener noreferrer"
          target="_blank"
        >
          Wide Angle Podium
        </a>
        , Rouleur Derby is free to play, and it is the only fantasy cycling game
        to be based on the parimutuel style of betting. In this format, odds are constantly in motion, depending on how many points players
        bet on any given outcome. The longer the odds, the greater the reward.
      </p>
      <p>
        In addition to predicting the winners of races, players can wager on
        various fun and interesting prop bets. Popular examples include: “Who
        will get over the Poggio first?” and “Will there be a dog- or
        livestock-related crash at the Tour de France?”{" "}
      </p>
      <p>
        Rouleur Derby will also be one of the few instruments with which fans
        can bet on the outcome of women’s races. In addition, it will cover cyclocross as well as road.
      </p>
      <p>
        Propositions open with a “morning line” established by the house. From
        there, odds change with each bet, using Rouleur Derby’s proprietary algorithms to reflect the wisdom
        of the crowd.
      </p>
      <p>
        “Morning-line odds are based on a combination of exhaustive research and machine
        learning,” says Hiro Boyd, Rouleur Derby’s senior director of play and
        quantitative analysis. “In the end, however, nothing beats a good
        hunch.”
      </p>
      <p>
        Rouleur Derby first launched in 2010 and went on hiatus after the
        2013 season. Like any cyclist after a taper period, it is returning
        faster, more rested, and better looking.
      </p>
      <p>
        New this season, Rouleur Derby is partnering with Wide Angle Podium, the
        world’s finest network of independent cycling podcasts. Wide Angle
        Podium will be producing a podcast to discuss weekly Rouleur Derby odds,
        and members of Wide Angle Podium get a bonus when they join Rouleur
        Derby.
      </p>
      <p>
        “Rouleur Derby is almost certainly the world's greatest fantasy cycling
        game,” says Spencer Haugh, Wide Angle Podium CEO and co-host of The
        Slow Ride Podcast. “Our partnership is another huge step for WAP toward
        our goal of dominating the cycling infotainment niche.”
      </p>
      <p>
        Action opens with this week’s Tirreno-Adriatico and will heat
        up for Milan-San Remo, where Peter Sagan opens as a 5/1 favorite.
      </p>
      <p>
        Players can join Rouleur Derby at any time. To get in on the fun, go to{" "}
        <Link to="/">https://www.rouleurderby.com.</Link>
      </p>
      <p>
        For further information, contact Luke Seemann, Rouleur Derby’s creator
        and owner, at{" "}
        <a href="mailto:info@rouleurderby.com">info@rouleurderby.com</a>.
      </p>
    </Fragment>
  );
}

export default Rules;
